import { Component } from '@angular/core';
import {TableComponent} from "../../../shared/components/table/table.component";

@Component({
  selector: 'app-canceled',
  standalone: true,
    imports: [
        TableComponent
    ],
  templateUrl: './canceled.component.html',
  styleUrl: './canceled.component.scss'
})
export class CanceledComponent {
  configurationTable: any = {
    "columns": [
      {
        "id": "cs.id",
        "title": "Clave",
        "type": "text",
        "placeholder": "",
        "required": false,
        "hide": true
      },
      {
        "id": "s.id",
        "title": "Orden de servicio",
        "type": "text",
        "placeholder": "",
        "required": false,
      },
      {
        "id": "cs.cancellation_date",
        "title": "Fecha",
        "type": "text",
        "onlyTable": true
      },
      {
        "id": "s.passenger_name",
        "title": "Nombre del cliente",
        "type": "text",
        "onlyTable": true
      },
      {
        "id": "dt.service_type",
        "title": "Tipo de servicio",
        "type": "text",
        "onlyTable": true
      },
      {
        "id": "dt.location_description",
        "title": "Ubicación",
        "type": "text",
        "onlyTable": true
      },
      {
        "id": "origin.configurableListsCode",
        "title": "Punto origen",
        "type": "text",
        "onlyTable": true
      },
      {
        "id": "destination.configurableListsCode",
        "title": "Punto destino",
        "type": "text",
        "onlyTable": true
      },
      {
        "id": "cv.description",
        "title": "Categoría de vehículo",
        "type": "text",
        "onlyTable": true
      },
      {
        "id": "bilingual_operator",
        "title": "Conductor bilingüe",
        "condition": "IF(dt.bilingual_operator>0, 'Si', 'No')",
        "type": "text",
        "onlyTable": true
      },
      {
        "id": "date_init",
        "title": "Fecha de inicio",
        "type": "text",
        "onlyTable": true
      },
      {
        "id": "date_end",
        "title": "Fecha de término",
        "type": "text",
        "onlyTable": true
      },
      {
        "id": "reason.configurableListsCode",
        "title": "Motivo",
        "type": "text",
        "onlyTable": true
      },
      {
        "id": "cs.cancellation_cost",
        "title": "Costo cancelación",
        "type": "currency",
        "onlyTable": true
      },
    ],
    "config": "canceled",
    "sortColumn": "cs.cancellation_date",
    "sortDirection": "DESC",
    "title": "Cancelados",
    "filterPrincipal": [
    ],
    "filters":[]
  };
}
